// The 7D / 30D / 90D range selector drawn on frames 11 and 12 as three
// `Primitive/Chip` instances.
//
// THE PROMOTION HAPPENED. This file used to carry three `Button`s in a radio
// group and a note saying it should move into `ui/` once a second screen
// needed chips. Four now do — this, the corpus picker, and the clock's
// granularity and cycle controls — so the control is `ui/ChipGroup` and this
// is the range-specific wrapper over it. The public API is unchanged, so no
// call site moved.

import { ChipGroup } from "../../ui";
import "./analytics.css";

export const RANGE_DAYS = [7, 30, 90] as const;
export type RangeDays = (typeof RANGE_DAYS)[number];

export const DEFAULT_RANGE: RangeDays = 30;

export function isRangeDays(value: unknown): value is RangeDays {
  return RANGE_DAYS.includes(value as RangeDays);
}

export type RangeChipsProps = {
  days: RangeDays;
  onChange: (days: RangeDays) => void;
};

export function RangeChips({ days, onChange }: RangeChipsProps) {
  return (
    <div className="maisight-analytics-range">
      <ChipGroup
        label="Time range"
        value={days}
        onChange={(next) => onChange(next as RangeDays)}
        options={RANGE_DAYS.map((option) => ({
          value: option,
          label: `${option}d`,
        }))}
      />
    </div>
  );
}
